import React, { useState } from 'react';
import { View, Text, TextInput, Pressable, ActivityIndicator } from 'react-native';
import { loginUser, refreshAuth } from '../lib/auth';

type Props = {
  onSuccess: () => void;
  onBackToDeviceLogin?: () => void;
};

export function UserLoginScreen({ onSuccess, onBackToDeviceLogin }: Props) {
  const [identity, setIdentity] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const doLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const userId = await loginUser(identity.trim(), password);
      await refreshAuth();
      if (userId) {
        onSuccess();
      } else {
        setError('Login succeeded but no user id returned');
      }
    } catch (e: any) {
      setError(e?.message ?? 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <Text style={{ fontSize: 28, marginBottom: 24 }}>User login</Text>
      <TextInput
        placeholder="Email"
        autoCapitalize="none"
        autoCorrect={false}
        value={identity}
        onChangeText={setIdentity}
        style={{ width: '70%', borderWidth: 1, borderColor: '#ccc', borderRadius: 10, padding: 12, marginBottom: 12 }}
      />
      <TextInput
        placeholder="Password"
        secureTextEntry
        value={password}
        onChangeText={setPassword}
        style={{ width: '70%', borderWidth: 1, borderColor: '#ccc', borderRadius: 10, padding: 12, marginBottom: 16 }}
      />
      <Pressable
        disabled={loading || !identity || !password}
        onPress={doLogin}
        style={({ pressed }) => ({
          opacity: loading || !identity || !password ? 0.6 : 1,
          backgroundColor: pressed ? '#0ea5e9' : '#0284c7',
          paddingVertical: 12,
          paddingHorizontal: 24,
          borderRadius: 10,
          marginBottom: 12,
        })}
      >
        {loading ? <ActivityIndicator color="#fff" /> : <Text style={{ color: 'white', fontSize: 18 }}>Sign in</Text>}
      </Pressable>
      <Pressable onPress={onBackToDeviceLogin}>
        <Text style={{ color: '#2563eb' }}>Back to device login</Text>
      </Pressable>
      {error && <Text style={{ color: 'red', marginTop: 12 }}>{error}</Text>}
    </View>
  );
}


